module.exports = __webpack_public_path__ + "img/taib6.98696717.png";